export default "__VITE_ASSET__41fd9781__"